export default __webpack_public_path__ + "static/media/tickInsideCircle.754915fb.svg";